import * as React from 'react'

import { toJS } from 'mobx'

import { observer } from 'mobx-react'

import type { TextProps } from 'modules/core/components/Inputs/types'
import TextField from 'modules/core/components/TextField'

const Text = ({
  type = 'text',
  onClick,
  onChange,
  onFocus,
  onBlur,
  onKeyDown,
  autofocus,
  label,
  hideLabel = false,
  field,
  value,
  placeholder,
  getRef,
  focused,
  readonly,
  description,
  secondaryLabel,
  ariaHidden,
  completed,
  loading = false,
  mandatory,
  select = false,
  validation,
  min,
  step,
  indicator = null,
  isClickableIcon,
  autofilled = false,
  attachmentPosition,
  error: givenError,
  extra,
}: TextProps) => {
  const [fieldErrors, setFieldErrors] = React.useState<Array<string | null | undefined>>([])

  React.useEffect(() => {
    setFieldErrors(toJS(field.errors) ?? [])
  }, [field.errors]) // FIXME: talk with Pau about this
  function onChangeEvent(value: string) {
    field.set(value)
    if (validation) {
      const validationErrors = validation(field.value)
      setFieldErrors([validationErrors, ...fieldErrors])
    }
    onChange && onChange(field)
  }
  let Component
  if (select) {
    Component = TextField.Select
  } else {
    Component = TextField
  }

  const error = fieldErrors[0] || givenError

  return (
    <Component
      label={label}
      hideLabel={hideLabel}
      focused={focused}
      readonly={readonly}
      description={description}
      secondaryLabel={secondaryLabel}
      completed={onChange ? completed : null}
      loading={loading}
      getRef={getRef}
      mandatory={mandatory && !readonly}
      ariaHidden={ariaHidden}
      autofocus={autofocus}
      onFocus={onFocus}
      onChange={onChangeEvent}
      onClick={onClick}
      onKeyDown={onKeyDown}
      onBlur={onBlur}
      type={type}
      placeholder={placeholder}
      value={value || field.value || ''}
      min={min}
      step={step}
      error={error || undefined}
      indicator={indicator}
      isClickableIcon={isClickableIcon}
      autofilled={autofilled}
      attachmentPosition={attachmentPosition}
      extra={extra}
    />
  )
}

export default observer(Text)
